import React, { useEffect, useRef, useState } from "react";
import uuid from "react-uuid";
import { Snackbar } from "@material-ui/core";
import CircularProgress from "@mui/material/CircularProgress";
import dayjs from "dayjs";

import { CometdActions } from "../../cometD/cometD-action";
import { useCometdContext } from "../../cometD/cometdProvider";
import DummyAgentImage from '../../images/DummyAgent.svg'
import { supportedFileFormats } from "../../utils/Constants/Constants";
import ReloadSessionContainer from "../../utils/ReloadSessionContainer/ReloadSessionContainer";
import DefaultFooter from "../CommonUtils/DefaultFooter";
import HWLog from "../HWLibrary/HWLog";
import apiService from "../Services/APIService";
import { sendNotification } from "../Services/HWIframeBridge";
import { s360ConfigService } from "../Services/S360Config";
import xmppService from "../Services/XMPPService";

import { MessageType } from "./MessageBoxTypes/Message";
import Conversation from "./Conversation";
import ConversationHeader from "./ConversationHeader";
import InputBox from "./InputBox";
import Popup from "./Popup";
import PreviewAttachmentFiles from "./PreviewAttachmentFiles";
import SendChatTranscriptForm from "./SendChatTranscriptForm";
import TypingIndicator from "../CommonUtils/TypingIndicator";

import "./ConversationStyleSheet.css";
import "react-modal-overlay/dist/index.css";

let tempFilesArray = [];
let tempArray = [];
let renderCount = 0;
let internetListenerAdded = false;
let healthPingCounter = 0;
let agentNotificationMessageIds = [];
let agentNotificationMessageIdsCopy = [];

let loopMessagerecived = false;
let dummyMesages = [
  {
    message: {
      text: "Reach out to our team of experts at any time.",
      sentTimestamp: 1697625572236,
      id: 1697625572236,
      showSingleTick: false,
    },
    id: 1697625572236,
    type: "RECIEVED",
    timestamp: 1697625572236,
    convoType: "TEXT",
    creator: "BOT",
    syntheticMessage: true,
  },
  {
    message: {
      text: "Hey, I’d like some help with refund.",
      sentTimestamp: 1697625572237,
      id: 1697625572237,
      showSingleTick: false,
    },
    id: 1697625572237,
    type: "SENT",
    timestamp: 1697625572237,
    convoType: "TEXT",
    creator: "CUSTOMER",
    syntheticMessage: true,
  },
  {
    message: {
      text: "Of course, can you confirm your identity?",
      sentTimestamp: 1697625572238,
      id: 1697625572238,
      showSingleTick: false,
    },
    id: 1697625572238,
    type: "RECIEVED",
    timestamp: 1697625572238,
    convoType: "TEXT",
    creator: "BOT",
    syntheticMessage: true,
  },
  {
    message: {
      text: "Sure, my name’s John.",
      sentTimestamp: 1697625572239,
      id: 1697625572239,
      showSingleTick: false,
    },
    id: 1697625572239,
    type: "SENT",
    timestamp: 1697625572239,
    convoType: "TEXT",
    creator: "CUSTOMER",
    syntheticMessage: true,
  },
];

function ConversationPage(props) {
  renderCount++;
  console.log(renderCount, "renderCount")
  const cometd = useCometdContext();
  const messageRef = useRef();
  const file = useRef();
  const { isShowLanguageDropdown, setIsShowLanguageDropdown, selectedLanguage, setSelectedLanguage } = props

  const iframeTrigger = useRef(false);
  const ackTrigger = useRef(false);
  const [messages, setMessages] = useState(tempArray);
  const [xmppMessageHistory, setXmppMessageHistory] = useState([]);
  const [previewFiles, setPreviewFiles] = useState([]);
  const [isConversationClosed, setIsConversationClosed] = useState(false);
  const [showSnackBar, setShowSnackBar] = useState(false);
  const [showSendChatTranscriptForm, setShowSendChatTranscriptForm] =
    useState(false);
  const [showCloseDialog, setShowCloseDialog] = useState(false);
  const [isFetchingMessages, setIsFetchingMessages] = useState(false);
  const [isReset, setIsReset] = useState(false);

  const [showGif, setShowGif] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [finalValue] = useState(null);
  const [messageLoader, setMessageLoader] = useState(false);
  const [isFetchingMessagesBelow, setIsFetchingMessagesBelow] = useState(false);
  const [showChatStatusLang, setShowChatStatusLang] = useState(
    props?.config?.chatStatusLangtoggle || true
  );
  const [showChatStatusAttachment, setShowChatStatusAttachment] =
    useState(false);
  const [disableLoader] = useState(false);
  const [historyFetched, setHistoryFetched] = useState(false)
  const [customerAckObj] = useState({});
  const [showAckMsg, setShowAckMsg] = useState(false);
  const [setMsgValue, setSetMsgValue] = useState({});
  const [showReloadPopup, setShowReloadPopup] = useState(false);
  const [showLoaderBotPopup, setShowLoaderBotPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [agentPingStatus, setAgentPingStatus] = useState();
  const [showMessagesFromStart, setShowMessagesFromStart] = useState(false);
  const [snackBarMessage, setSnackBarMesssage] = useState("");
  const [open, setOpen] = useState(false);
  const [playSound, setPlaySound] = useState(false);
  const [showTyping, setShowTyping] = useState(false);
  const [isTypingPublished, setIsTypingPublished] = useState(false)
  const isFullScreen = localStorage.getItem("openInFullScreen");
  let audio = null;
  if (s360ConfigService.config?.notification?.audio !== undefined && s360ConfigService.config?.notification?.audio !== null) {
    audio = new Audio();
    audio.src = './notification.mp3';
  }
  let defaultMessage = "Type a message...";
  let loaderTimeOut = 0;
  let msgIdTimer = {};

  let clearMsgIds = {};

  const initialize = () => {


    if (s360ConfigService?.config?.sandBox) {
      addMessagesToList(dummyMesages);
    } else {
      if (!internetListenerAdded && props?.config?.healthCheck) {
        handleConnectionChange();
      }
      if (props?.config?.healthCheck) {
        window.addEventListener("online", handleConnectionChange);
        window.addEventListener("offline", handleConnectionChange);
      }

      setTimeout(() => setIsFetchingMessagesBelow(false), loaderTimeOut);

      initialActionCometd(props.conversation);
      if (s360ConfigService?.config?.sandBox === undefined) {

        CometdActions(cometd);
      }

      const isAgentWaiting = sessionStorage.getItem("agentWaiting");
      const isAgentConnected = sessionStorage.getItem("agentConnected");
      if (props?.uniboxSingleRefresh) {
        parseUniboxSinleRefreshRespone();
      }

      if (!isAgentConnected && isAgentWaiting) {
        if (s360ConfigService.config?.agentNotificationMessages?.length) {
          let tempIntervalMessages =
            s360ConfigService.config.agentNotificationMessages;
          agentNotificationMessageIds = tempIntervalMessages.map(
            (oneMessage) => oneMessage.id
          );
          agentNotificationMessageIdsCopy = tempIntervalMessages.map(
            (oneMessage) => oneMessage.id
          );
          tempIntervalMessages.forEach((oneIntervalMessage) =>
            createDynamicIntervals(oneIntervalMessage)
          );
        }
      }
    }
  };

  const updateComponent = (event) => {

    if (
      event.detail &&
      event.detail.componentsToUpdate &&
      event.detail.componentsToUpdate.indexOf("ConversationPage") >= 0
    ) {
      const eventData = event?.detail?.data ?? {};
      console.log(
        "COMETD-LOG:RECIEVED MESSAGE FROM COMETD",
        JSON.parse(eventData.message.data)
      );

      cometdActions(JSON.parse(eventData.message.data));
    }
  };

  useEffect(() => {

    document.addEventListener("updateComponent", updateComponent);
    initialize();

    return () => {
      document.removeEventListener("updateComponent", updateComponent);
      tempArray = [];
    };


  }, []);

  const handleUpdateTypingStatus = (isTyping = false) => {
    if (isTyping && isTypingPublished)
      // typing is true but already typing published, then don't publish again
      return

    if (!isTyping && !isTypingPublished)
      // typing is false & also typing is not published then no need to publish
      return

    let sessionId = props?.activeConversation?.sessionId || ""
    if (!sessionId) {
      HWLog.warn("No SessionId available to send typing status");
      return;
    }

    // send typing status through cometD
    const { sendTypingIndicatorMessage } = CometdActions(cometd);
    sendTypingIndicatorMessage(sessionId, isTyping);
    setIsTypingPublished(isTyping)
  }

  // TODO: very brittle code, needs to be refactored
  useEffect(() => {
    if (iframeTrigger.current) {
      if (!s360ConfigService?.config?.sandBox) {
        if (s360ConfigService.config.hideIcon) {
          props.resetIframe();
        }

        parseSessionCloseResponse({ sessionId: props.sessionIdForClose });
      }
    } else {
      iframeTrigger.current = true;
    }
  }, [props?.isIframeClose]);

  // TODO: very brittle code, needs to be refactored
  useEffect(() => {
    if (ackTrigger.current) {
      if (!s360ConfigService?.config?.sandBox) {
        let currentTimer = setMsgValue?.message?.sentTimestamp;
        if (props?.config?.chatRetry) {
          let tempTimer = setTimeout(() => handleAckRetry(), 1000);

          clearMsgIds = { ...msgIdTimer, [currentTimer]: tempTimer };
          setShowAckMsg(false);
        }
      }
    } else {
      ackTrigger.current = true;
    }
  }, [showAckMsg]);

  useEffect(() => {
    return () => {
      removeHelathPingTimer();
      Object.keys(clearMsgIds).map((key) => {
        clearTimeout(clearMsgIds[key]);
      });

      if (props.config.healthCheck) {
        window.removeEventListener("online", handleConnectionChange);
        window.removeEventListener("offline", handleConnectionChange);
      }
    };
  }, []);
  useEffect(() => {
    if (props.chatStatus) {
      if (!s360ConfigService?.config?.sandBox && !historyFetched) {
        fetchConversationHistoryCometd()
      }
    }
  }, [props.chatStatus])

  const handleAckRetry = () => {
    let initialMsgArray = [];

    messages.forEach((el) => {
      let newEl = { ...el };
      if (
        newEl?.message?.id &&
        setMsgValue.hasOwnProperty(newEl.message?.id) &&
        !newEl.message.showSingleTick
      ) {
        newEl.message["showSingleTick"] = false;
      }
      initialMsgArray.push(newEl);
    });
    console.log(initialMsgArray, "initialMsgArray");
    setMessages(initialMsgArray);
  };

  const handleFileScan = async (file) => {
    let regexforFileExtension = /(?:\.([^.]+))?$/;

    if (
      !supportedFileFormats.includes(regexforFileExtension.exec(file.name)[0])
    ) {
      showSnackBarWithMessage(`${file.name} File format not supported.`);
      return;
    }
    setIsFetchingMessages(true);
    if (s360ConfigService?.config?.fileScan) {
      fetch("https://api.cloudmersive.com/virus/scan/file", {
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
          Apikey: "b05a4113-bf4d-42d3-a7b9-5506c269d6e2",
        },
        body: file,
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          setIsFetchingMessages(false);
          if (data.CleanResult) {
            if (file.size > 10485760) {
              showSnackBarWithMessage(
                `File size exceeds maximum limit 10 MBs and the file is ${file.name}`
              );
            } else {
              tempFilesArray.push(...previewFiles, file);
              const uploadFiles = tempFilesArray.reduce(
                (accumulator, current) => {
                  if (!accumulator.find((item) => item.name === current.name)) {
                    accumulator.push(current);
                  }
                  return accumulator;
                },
                []
              );

              setPreviewFiles(uploadFiles);
              file.current.value = "";
            }
          } else {
            showSnackBarWithMessage(
              `Upload blocked: Malicious file detected, for security reasons and the file is ${file.name}`
            );
          }
        })
        .catch(() => {
          // console.error("Error in handleFileScan", error);
          setIsFetchingMessages(false);
          showSnackBarWithMessage(
            "Something went wrong, Please try some other files"
          );
        });
    } else {
      tempFilesArray.push(...previewFiles, file);
      setIsFetchingMessages(true);
      if (file.size > 10485760) {
        showSnackBarWithMessage(
          `File size exceeds maximum limit 10 MBs and the file is ${file.name}`
        );
      } else {
        const uploadFiles = tempFilesArray.reduce(
          (accumulator, current) => {
            if (!accumulator.find((item) => item.name === current.name)) {
              accumulator.push(current);
            }
            return accumulator;
          },
          []
        );

        setPreviewFiles(uploadFiles);
        setIsFetchingMessages(false);
        // file.current.value = "";
      }
    }

  };

  const onFileSelect = async (e) => {
    if (e.target.files) {
      let files = e.target.files;
      for (let i = 0; i < files.length; i++) {
        await handleFileScan(files[i]);
      }
      if (tempFilesArray.length === 0) {
        tempFilesArray = [];
      }
    }
  };

  const onRemovePreviewFile = (file) => {
    const updatedFiles = (previewFiles || []).filter(
      (previewFile) => previewFile.name !== file.name
    );
    tempFilesArray = [];
    setPreviewFiles(updatedFiles);
  };

  const initialActionCometd = (conversation) => {
    if (s360ConfigService?.config?.sandBox) {
      conversation = {};
      conversation.sessionId = "1234";
      conversation.sessionStatus = "NEW";
    }
    //NOTE : Enhancement 2
    if (props?.config?.healthCheck) {
      agentHealthPingTimerId = setInterval(async () => {
        startFetchingHealthPings();
      }, 1000 * 60);
    }

    if (
      conversation?.sessionStatus === "New" &&
      parseInt(localStorage.getItem("CurrentActiveSession")) !==
      parseInt(conversation?.sessionId)
    ) {
      parseBotReplyResponse(conversation);
    } else {
      // fetchConversationHistoryCometd();
    }
    localStorage.setItem("CurrentActiveSession", conversation.sessionId);
  };

  const disableOnAgentConnections = () => {
    sessionStorage.setItem("agentConnected", "true");
    setShowChatStatusLang(false);
    setShowChatStatusAttachment(!s360ConfigService.config.hideAttachment);
  };

  const fetchConversationHistoryCometd = (lastFetchMessageId) => {
    // if (!props.config?.anonymous) {
    //   return;
    // }
    let sessionInfo = props.activeConversation;

    const { fetchHistoryCMD } = CometdActions(cometd);

    fetchHistoryCMD(sessionInfo, lastFetchMessageId, 30);
    setHistoryFetched(true)
  };

  const parseCustomerMsgAck = (message) => {
    if (props?.config?.chatRetry) {
      const initialMsgArray = [];
      if (
        message &&
        message?.msgId &&
        setMsgValue.hasOwnProperty(message.msgId)
      ) {
        messages.map((el) => {
          let ele = { ...el };
          if (el.id === message.msgId) {
            ele.message["showSingleTick"] = true;
          }
          initialMsgArray.push(ele);
        });
        console.log(initialMsgArray, "initialMsgArray2");
        setMessages(initialMsgArray);
      }
    }
  };

  const parseBotFromCustomerMsgAck = (message) => {
    if (props?.config?.chatRetry) {
      if (setMsgValue?.message?.showDoubleTick) {
        return;
      }

      let initialMsgArray = [];
      if (
        message &&
        message?.msgId &&
        setMsgValue.hasOwnProperty(message.msgId)
      ) {
        messages.map((el) => {
          let ele = { ...el };
          if (el.id === message.msgId) {
            ele.message["showDoubleTick"] = true;
            ele.message["showSingleTick"] = true;
            delete setMsgValue[message.msgId];
          }
          initialMsgArray.push(ele);
        });
        console.log(initialMsgArray, "initialMsgArray3");
        setMessages(initialMsgArray);
      }
    }
  };

  const parseAckAllAgentReply = () => {
    let tempArray = [];
    if (props?.config?.chatRetry) {
      messages.map((el) => {
        let ele = { ...el };
        if (ele.message.showSingleTick) {
          ele.message.showDoubleTick = true;
        }
        tempArray.push(ele);
      });
      console.log(tempArray, "initialMsgArray 5");
      setMessages(tempArray);
    }
  };

  //NOTE : Enhancement 3
  const parseSessionReload = () => setShowReloadPopup(true);

  const parseUniboxSinleRefreshRespone = () => {
    sessionStorage.setItem("agentWaiting", "true");
    const isAgentWaiting = sessionStorage.getItem("agentWaiting");
    const isAgentConnected = sessionStorage.getItem("agentConnected");
    if (!isAgentConnected && isAgentWaiting) {
      if (s360ConfigService.config?.agentNotificationMessages?.length) {
        let tempIntervalMessages =
          s360ConfigService.config.agentNotificationMessages;
        agentNotificationMessageIds = tempIntervalMessages.map(
          (oneMessage) => oneMessage.id
        );
        agentNotificationMessageIdsCopy = tempIntervalMessages.map(
          (oneMessage) => oneMessage.id
        );
        tempIntervalMessages.forEach((oneIntervalMessage) =>
          createDynamicIntervals(oneIntervalMessage)
        );
      }
    }
  };

  const cometdActions = (message) => {
    console.log(message, "COMETD-MESSAGE RECIEVED IN CONVERSATION PAGE");
    if (!message) return;
    //  To add more cases, add it in XMPPService class.
    switch (message.command) {
      case "HISTORY_RESPONSE":
        parseMessageHistoryResponse(message);
        break;
      case "UNIBOX_SINGLE_REFRESH":
        parseUniboxSinleRefreshRespone();
        break;
      case "PING_RESPONSE":
        parseAgentStatusPingResponse(message);
        break;
      case "SESSION_CLOSE": {
        console.log("SESS_BUG:1.USER HAS TYPED !QUIT/SESSION ENDED");
        parseSessionCloseResponse(message);
        break;
      }
      case "CHAT_STATUS":
        parseChatStatusResponse(message);
        break;
      case "BOT_REPLY":
        parseBotReplyResponse(message);
        break;
      case "AGENT_REPLY":
        parseAgentReplyResponse(message);
        break;
      case "SESSION_NOTIFICATION":
        parseAgentReplyResponse(message);
        break;
      case "TYPING_INDICATOR":
        parseTypingIndicatorResponse(message);
        break;
      case "SEND_CHAT_TRANSCRIPT_RESPONSE":
        parseChatTranscriptResponse(message);
        break;
      case "SURVEY_TRIGGER":
        props.parseSurveyTriggerResponse(message);
        break;
      case "ACK_BOT2CUSTOMER":
        console.log("ACK_BOT2CUSTOMER");
        parseCustomerMsgAck(message);
        break;
      case "ACK_CUSTOMER_REPLY":
        parseBotFromCustomerMsgAck(message);
        break;
      case "ACK_CUSTOMER_MESSAGES_FOR_SESSION":
        parseAckAllAgentReply(message);
        break;
      case "CREATE_SESSION": {
        console.log(
          "SESS_BUG:12. GOT A RESPONSE FROM XMPP FOR CREATE_SESSION--->",
          message
        );
        onCreateSessionResponse(message);
        break;
      }
      case "SESSION_RELOAD": {
        if (props.config.healthCheck) {
          parseSessionReload(message);
        }
        break;
      }
      default:
        break;
    }
    setIsFetchingMessagesBelow(false);
  };

  const onMessageSend = () => {
    let isMediaAttached = (previewFiles || []).length !== 0;
    let hasTextMessage = !(
      !messageRef.current.value ||
      !messageRef.current.value.trim() ||
      messageRef.current.value === defaultMessage
    );
    if (!isMediaAttached && !hasTextMessage) {
      return;
    }

    if (hasTextMessage && !isMediaAttached) {
      sendMessage(messageRef.current.value.trim());
    } else if (isMediaAttached) {
      let textMessage = hasTextMessage ? messageRef.current.value.trim() : null;
      setIsLoading(true);
      sendMessageWithAttachemnts(previewFiles, textMessage).finally(() => {
        tempFilesArray = [];
        setIsLoading(false);
        setPreviewFiles([]);
      });
    }
    messageRef.current.value = "";
  };

  const handleClose = () => {
    setShowGif(false);
  };

  const onSendChatTranscriptClick = () => setShowSendChatTranscriptForm(true);

  const sendChatTranscript = (emailId) => {
    setShowSendChatTranscriptForm(false);
    if (!emailId) {
      return;
    }
    const { sendChatTranscriptCMD } = CometdActions(cometd);
    sendChatTranscriptCMD(props.activeConversation, emailId);
  };

  const closeConversationClick = () => {
    localStorage.removeItem("finalvalue");
    setShowCloseDialog(false);
    setOpen(false);
    setIsReset(true);
    let sessionId =
      props.activeConversation && props.activeConversation.sessionId;
    if (!sessionId) {
      return;
    }
    const { closeSessionCMD } = CometdActions(cometd);
    closeSessionCMD(sessionId);
  };

  const handleSnackbarClose = () => setShowSnackBar(false);

  const showSnackBarWithMessage = (message) => {
    setShowSnackBar(true);
    setSnackBarMesssage(message);
  };

  const isActiveConversation = () => {
    let isClosed =
      props?.activeConversation?.active === false || isConversationClosed;
    return !isClosed;
  };

  const createInfoMessage = (id, message, interval, loop, intervalToClear) => {
    //TIMERTODO create and push message
    if (agentNotificationMessageIdsCopy.includes(id)) {
      let messageToShow = message;
      let messageTime = new Date();
      let chatInfoMessage = {
        message: { text: messageToShow, sentTimestamp: messageTime.getTime() },
        id: `agent-info-message${id}+${messageTime.getTime()}`,
        type: MessageType.info,
        timestamp: messageTime.getTime(),
        convoType: "TEXT",
        syntheticMessage: true,
      };
      addMessagesToList([chatInfoMessage]);
      if (!loop) {
        const index = agentNotificationMessageIdsCopy.indexOf(id);
        if (index > -1) {
          // only splice array when item is found
          agentNotificationMessageIdsCopy.splice(index, 1); // 2nd parameter means remove one item only
        }
        clearInterval(intervalToClear);
      } else if (loop && loopMessagerecived !== id) {
        const index = agentNotificationMessageIdsCopy.indexOf(id);
        if (index > -1) {
          // only splice array when item is found
          agentNotificationMessageIdsCopy.splice(index, 1); // 2nd parameter means remove one item only
        }
        clearInterval(intervalToClear);
      }
    }
    // clear id value in array id loop false
  };

  const setLoopMessageInterval = (id, message, interval, loop) => {
    agentNotificationMessageIds[agentNotificationMessageIds.indexOf(id)] =
      setInterval(() => {
        createInfoMessage(id, message, interval, loop);
      }, interval * 1000);
  };

  const setNormalMessageInterval = (id, message, interval, loop) => {
    let tempinterval = setInterval(() => {
      createInfoMessage(id, message, interval, loop, tempinterval);
    }, interval * 1000);
  };

  const createDynamicIntervals = (data) => {
    const { id, message, interval, loop } = data;
    if (loop && !loopMessagerecived) {
      setLoopMessageInterval(id, message, interval, loop);
      loopMessagerecived = id;
    } else {
      setNormalMessageInterval(id, message, interval, loop);
    }
  };

  const handleConnectionChange = () => {
    const condition = navigator.onLine ? "online" : "offline";
    if (condition === "offline") {
      setShowLoaderBotPopup(true);
      setShowErrorMsg(
        "Seems you lost your internet connection Please check your network"
      );
    } else if (condition === "online") {
      setShowLoaderBotPopup(false);
      if (internetListenerAdded) {
        setShowReloadPopup(true);
      }
    }

    internetListenerAdded = true;
  };

  const isOnSameDay = (date, anotherDate) => {
    return (
      dayjs.unix(date).format("YY MMM DD") ===
      dayjs.unix(anotherDate).format("YY MMM DD")
    );
  };

  const disablePreviousButtonsOnHistory = (msgs) => {
    const newMessages = msgs;

    let enabledLastBotMessage = false;
    if (newMessages.length > 0) {
      if (newMessages.length === 1) {
        newMessages.forEach((m) => (m.disabled = false));
      } else {
        for (let i = newMessages.length - 1; i >= 0; i--) {
          if (enabledLastBotMessage) {
            newMessages[i].disabled = true;
          } else {
            if (newMessages[i].creator === "BOT") {
              newMessages[i].disabled = false;
              enabledLastBotMessage = true;
            }
          }
        }
      }
    }
    console.log(newMessages, "initialMsgArray 7");
    setMessages(newMessages);
  };

  const parseMessageHistoryResponse = (message) => {

    setShowLoaderBotPopup(false);

    const isAgentConnected = sessionStorage.getItem("agentConnected");
    if (isAgentConnected) {
      disableOnAgentConnections();
    }
    localStorage.removeItem("autoOpenChat");
    HWLog.info("HISTORY_RESPONSE LIST MESSAGES", message);
    if (!message.listHistoryInfo || message.listHistoryInfo.length === 0) {
      setIsFetchingMessages(false);
      HWLog.info("EMPTY HiSTORY LIST");
      return;
    }
    let messagesToAdd = message.listHistoryInfo || [];
    messagesToAdd = messagesToAdd.map((i) => {
      i.id = i.id + "";
      let check = checkEmoji(i.message.text);
      if (i.convoType === "TEXT" && check) {
        i.convoType = "EMOJI";
      }
      return i;
    });

    messagesToAdd.map((messageToAdd) => {
      if (messageToAdd?.message?.chatResponse?.entries) {
        messageToAdd?.message?.chatResponse?.entries.map((entry, index) => {
          if (entry?.uiCommand === "A99") {
            messageToAdd?.message?.chatResponse?.entries.splice(index, 1);
          }
          return messageToAdd;
        });
      }
      return messagesToAdd;
    });

    addMessagesToList(messagesToAdd.reverse());
    disablePreviousButtonsOnHistory(messagesToAdd);
  };

  const parseSessionCloseResponse = (message) => {
    let sessionId = message.sessionId || "";
    let activeSessionInfo = props.activeConversation || {};
    console.log("props.activeConversation", props.activeConversation);
    if (activeSessionInfo.sessionId === sessionId) {
      props.actions.markActiveConversationAsClosed();
      let sessionCloseMessage = getSessionCloseMessage();
      if (s360ConfigService?.config?.configDetails?.startNewSession) {
        addMessagesToList([sessionCloseMessage]);
      }
    } else {
      showSnackBarWithMessage("Could not close coversation, please try again.");
    }
  };

  // Add Agent Transfer Ino Message.
  const parseChatStatusResponse = (message) => {
    agentNotificationMessageIds = [];
    agentNotificationMessageIdsCopy = [];
    disableOnAgentConnections();
    let sessionId = message.sessionId || "";
    let activeSessionInfo = props.activeConversation || {};
    if (activeSessionInfo.sessionId !== sessionId) {
      HWLog.warn("Invalid Chat Satus Session Id: ");
      return;
    }
    console.log(message, "agentmessageinfo")
    let firstName = (message.agentInfo && message.agentInfo.firstName) || "";
    let lastName = (message.agentInfo && message.agentInfo.lastName) || "";
    let showAgentInfo =
      props.config &&
      props.config.configDetails &&
      props.config.configDetails.showAgentInfo;
    if (!firstName.trim() || !lastName.trim()) {
      return;
    }
    let agentName = (firstName + " " + lastName).trim();
    sessionStorage.setItem("agentName", agentName);
    let messageToShow = "You are transferred to agent " + agentName;
    let messageTime = new Date();
    let chatInfoMessage = {
      message: { text: messageToShow, sentTimestamp: messageTime.getTime() },
      id: "agent-info-message",
      type: MessageType.info,
      timestamp: messageTime.getTime(),
      convoType: "TEXT",
      syntheticMessage: true,
    };

    addMessagesToList([chatInfoMessage]);
    let headerVal = document.getElementsByClassName(
      "s360-conversation-header-details-title"
    );
    let headerValfs = document.getElementsByClassName(
      "s360-conversation-header-details-title-fs"
    );

    for (let i = 0; i < headerVal.length; i++) {
      if (headerVal[i]) headerVal[i].innerHTML = agentName;
    }
    if (headerValfs) {
      for (let i = 0; i < headerValfs.length; i++) {
        if (headerValfs[i]) headerValfs[i].innerHTML = agentName;
      }
    }
    // let agentDisplayInitials =
    //   message.agentInfo &&
    //     message.agentInfo.firstName &&
    //     message.agentInfo.lastName
    //     ? message.agentInfo.firstName.charAt(0) +
    //     "" +
    //     message.agentInfo.lastName.charAt(0)
    //     : "B";
    const agentImage = DummyAgentImage
    const brandIcon = s360ConfigService?.config?.configDetails?.brandIcon;
    const agentProfilePic = message?.agentInfo?.userProfilePic;
    if (showAgentInfo) {
      document.getElementById("s360-agent-image").src = agentProfilePic || brandIcon || agentImage;
    }
  };

  const parseBotReplyResponse = (message) => {
    console.log("CONVESSAGE1222@", message)
    ackBotReply(message);

    let messageTime = new Date();
    let sessionId = message.sessionId || "";
    let activeSessionInfo = props.activeConversation || {};
    if (activeSessionInfo.sessionId !== sessionId) {
      HWLog.info("Invalid Session Id: For BOT REPLY: ", message || {});
      return;
    }
    // console.log("5.TRIGERRED  BOT MESSAGE    BEFORE ADDING TO ARRAY",message)
    if (!message.id) {
      message.id = uuid();
    }
    message.id = message.id + "";
    message.message.sentTimestamp = messageTime.getTime();

    // console.log("6.TRIGERRED BOT MESSAGE    AFTER ADDING TO ARRAY",message)

    addMessagesToList([message]);
    if (s360ConfigService.config.notification.isEnabled && playSound) {
      audio?.play();
    }
    if (props.config.configDetails?.browserNotification) {
      if (message.message?.chatResponse?.entries?.length) {
        message.message.chatResponse.entries.forEach(entry => sendNotification(entry.text));
      } else if (message.message?.text) {
        sendNotification(message.message?.text)
      }
    }
  };

  const ackBotReply = (payload) => {
    const result = { ...payload };
    result.command = "ACK_BOT_REPLY";
    const { sendBotAckMessage } = CometdActions(cometd);
    sendBotAckMessage(result?.sessionId, result, "TEXT");
  };

  const parseAgentReplyResponse = (message) => {
    if (message.command === "AGENT_REPLY") {
      ackAgentClientMsg(message);
    }
    let sessionId = message.sessionId || "";
    let activeSessionInfo = props.activeConversation || {};
    if (activeSessionInfo.sessionId !== sessionId) {
      HWLog.info("Invalid Session Id: For AGENT REPLY: ", message || {});
      return;
    }
    if (!message.id) {
      message.id = uuid();
    }
    message.id = message.message.sentTimestamp;
    message.creator = "AGENT";
    let newMessageToSend = {
      message: {
        text: message.message.text,
        sentTimestamp: message.message.sentTimestamp,
        id: message.id,
      },
      id: message.id,
      type: MessageType.received,
      timestamp: message.message.sentTimestamp,
      convoType: message.convoType,
      creator: "AGENT",
      syntheticMessage: true,
    };
    console.log(newMessageToSend, "newMessageToSend")
    addMessagesToList([newMessageToSend]);
    if (s360ConfigService.config.notification.isEnabled && playSound) {
      audio?.play();
    }
    if (props.config.configDetails?.browserNotification) {
      console.log("NOTIF-LOG:SENDING FROM CONVERSATIONPAGE")
      sendNotification(message.message.text);
    }
  };

  const ackAgentClientMsg = (payload) => {
    const result = { ...payload };
    result.command = "ACK_AGENT_REPLY";

    result["sentTimestamp"] = result.originalTimeStamp;
    if (payload.message.translatedText) { result["message"]["text"] = payload.message.translatedText }
    const { sendAckAgentMessage } = CometdActions(cometd);
    sendAckAgentMessage(result?.sessionId, result, "TEXT");
  };

  const parseTypingIndicatorResponse = (message) => {
    // if it's an Agent typing then only process the request
    if (message.typer !== "AGENT")
      return
    let isTyping = message.typing || false;
    let sessionId = message.sessionId || "";
    let activeSessionInfo = props.activeConversation || {};
    if (activeSessionInfo.sessionId !== sessionId) {
      HWLog.info("Invalid Session Id: For Typing Indicator: ", message || {});
      return;
    }
    setShowTyping(isTyping);
  };

  const parseChatTranscriptResponse = () =>
    props.actions.showPopUpMessage(
      "The transcript is sent to your preferred Email ID"
    );
  function removeDuplicates(array) {
    const tolerance = 1000; // Adjust the tolerance value as needed

    return array.reverse().filter((message, index, self) => {
      const currentTimestamp = Number(message.message.sentTimestamp);
      const firstIndex = self.findIndex(
        (m) =>
          m.message.text === message.message.text &&
          Math.abs(Number(m.message.sentTimestamp) - currentTimestamp) <= tolerance
      );

      return index === firstIndex;
    }).reverse();
  }

  const addMessagesToList = (messagesToAdd) => {

    if (!s360ConfigService.config.sandBox) {
      props.increaseMessageCounter();
    }

    if (!messagesToAdd || messagesToAdd.length === 0) {
      return;
    }

    let newMessagesToAdd = messagesToAdd.filter((msg) => msg.message.text !== "IGNORE-IN-MESSAGES-ARRAY");
    let sortedMessagesList = [...messages, ...newMessagesToAdd];
    console.log(sortedMessagesList, "DEBUG 1 SORTED");
    let parsedMessages = parseMessagesForTimeStamps(sortedMessagesList);
    parsedMessages = removeDuplicates(parsedMessages, "message");
    console.log(sortedMessagesList, "DEBUG 2 PARSED");
    console.log(parsedMessages, "initialMsgArray 10");
    tempArray.push(...parsedMessages);
    setMessages(parsedMessages);

    setIsFetchingMessages(false);
    disablePreviousButtonsOnHistory(parsedMessages);
    console.log(messages, "DEBUG 3 FINAL");
  };


  const parseMessagesForTimeStamps = (messagesList) => {
    console.log(messagesList, "DEBUG # FINAL");
    let messageList = [];
    let datePointer = null;
    let messages = messagesList.filter((i) => !i.syntheticDateInfoMessage); // Filter out synthetic date info messages.
    let messageIds = messages.map((i) => i.id);
    messages.forEach((message, index) => {
      // if (message?.id === "session-close-message") {
      //   return;
      // }

      if (
        !(
          datePointer &&
          isOnSameDay(datePointer, message?.message?.sentTimestamp / 1000)
        )
      ) {
        let messageDateTimeText = dayjs
          .unix(message?.message?.sentTimestamp / 1000)
          .format("DD MMM YYYY");
        if (messageIds.indexOf(messageDateTimeText) === -1) {
          messageList.push({
            message: {
              text: messageDateTimeText,
              sentTimestamp: message.message.sentTimestamp,
            },
            id: messageDateTimeText,
            type: MessageType.info,
            timestamp: message.message.sentTimestamp,
            syntheticMessage: true,
            syntheticDateInfoMessage: true,
          });
          datePointer = message.message.sentTimestamp / 1000;
        } else {
          alert("exited");
        }
      }
      message.type = parseMessageType(message.creator, index);
      console.log("DEBUG 4 PUSH", message);
      messageList.push(message);
    });
    if (!isActiveConversation()) {
      // Add session close message, if current session is closed.
      let sessionCloseMessage = getSessionCloseMessage();
      if (
        sessionCloseMessage &&
        s360ConfigService?.config?.configDetails?.startNewSession
      ) {
        messageList.push(sessionCloseMessage);
      }
    }
    console.log(messageList);
    return messageList;
  };

  const parseMessageType = (creator, index) => {
    if (creator === "CUSTOMER") {
      return MessageType.sent;
    } else if (creator === "BOT" || creator === "AGENT") {

      return MessageType.received;
    } else {
      if (index === 1) { //to see that 1st message is not from csutomer as everytime customer's type will be SENT
        return MessageType.received
      }
      else {
        return MessageType.info;
      }

    }
  };

  // MARK : New Ccnversation
  let doMoveToNewConversation = false;
  const startNewConversation = () => {
    window.parent.postMessage(
      {
        resetFromNewButton: "true",
      },
      "*"
    );
    localStorage.setItem("autoOpenChat", "true");
  };

  const onCreateSessionResponse = (newSessionResponse) => {
    if (doMoveToNewConversation) {
      props.actions.startConversation(newSessionResponse, () => {
        setMessages([]);
        console.log(messages, "initialMsgArray 11");
        setXmppMessageHistory([]);
        setIsConversationClosed(false);
        setShowSnackBar(false);
        setShowSendChatTranscriptForm(false);
      });
    }
  };

  let agentHealthPingTimerId = null;

  //NOTE : Enhancement 5
  const startFetchingHealthPings = () => {
    if (healthPingCounter > 2) {
      setShowReloadPopup(true);
    } else {
      healthPingCounter++;
      if (!isActiveConversation()) {
        return;
      }
      let sessionId = props.activeConversation.sessionId;
      if (!sessionId) {
        HWLog.warn("No Session Id Available To Fetch Agent Health Ping: ");
        return;
      }
      const { sendHealthPing } = CometdActions(cometd);
      sendHealthPing(sessionId);
    }
  };

  const removeHelathPingTimer = () => {
    if (agentHealthPingTimerId) {
      clearInterval(agentHealthPingTimerId);
    }
  };

  //  GREEN - Online
  //  RED - Offline
  //  Yellow - Away
  const parseAgentStatusPingResponse = (message) => {
    healthPingCounter--;
    let sessionId = message.sessionId || "";
    let activeSessionInfo = props.activeConversation || {};
    if (activeSessionInfo.sessionId !== sessionId) {
      HWLog.info(
        "Invalid Session Id: For Agant Health Ping Response: ",
        message || {}
      );
      return;
    }
    let status = (message.onlineStatus && message.onlineStatus.status) || "";
    let isValidStatus = ["GREEN", "RED", "Yellow"].indexOf(status) !== -1;
    if (!isValidStatus) {
      HWLog.info("Invlaid Ping Status From Server: ", message || {});
      return;
    }
    HWLog.info("AGENT PING STATUS: " + status);
    setAgentPingStatus(status);
  };

  // MARK: Actions
  const actions = {
    sendMessage: (message) => sendMessage(message),
    sendMessageWithAttachemnts: (files, textMessage) =>
      sendMessageWithAttachemnts(files, textMessage),
    sendTypingStatus: (typing) => sendTypingStatus(typing),
    sendMessageWithCode: (textMessage, dispalyMessage) =>
      sendMessageWithCode(textMessage, dispalyMessage),
    disableOnAgentConnections: () => disableOnAgentConnections(),
    handleShowReloadPopup: () => handleShowReloadPopup(),
  };

  const handleShowReloadPopup = () => {
    if (props?.config?.healthCheck) {
      setShowReloadPopup(true);
      setShowLoaderBotPopup(false);
    }
  };

  const sendTypingStatus = (typing) => {
    let sessionId =
      props.activeConversation && props.activeConversation.sessionId;
    if (!sessionId) {
      return;
    }
    HWLog.info("TYPING STATUS CHANGE: " + typing);
    xmppService.sendTypingIndicatorStatus(sessionId, typing).catch((error) => {
      HWLog.error(error, "Could not send typing status.");
    });
  };

  const checkEmoji = (textMessage) => {
    if (!textMessage) return;
    const regexpEmojiPresentation = /\p{Emoji_Presentation}/gu;
    const regex =
      /([\p{Alphabetic}\p{Mark}\p{Decimal_Number}\p{Connector_Punctuation}\p{Join_Control}]+)/gu;
    const specialChar = /[-[\]{}()*+!<=:?./\\^$|#\s,]/g;

    if (
      textMessage.match(regexpEmojiPresentation) != null &&
      textMessage.match(regexpEmojiPresentation).length === 1
    ) {
      if (
        textMessage.match(regex) == null &&
        textMessage.match(specialChar) == null
      ) {
        return true;
      }
    }
    return false;
  };

  const sendMessage = (textMessage) => {
    if (s360ConfigService.config.notification.isEnabled && playSound) {
      audio?.play();
    }
    setTimeout(() => setIsFetchingMessagesBelow(false), loaderTimeOut);
    const { sendMessageCMD } = CometdActions(cometd);
    let messageTime = new Date();
    let type = "TEXT";
    let id = messageTime.getTime();
    let newMessageToSend = {
      message: {
        text: textMessage,
        sentTimestamp: id,
        id: id,
      },
      id: id,
      type: MessageType.sent,
      timestamp: id,
      convoType: type,
      creator: "CUSTOMER",
      syntheticMessage: true,
    };
    let pendingMsg = { ...setMsgValue };
    let sessionInfo = props.activeConversation;
    let message = {
      text: textMessage,
      sentTimestamp: id,
      id: id,
    };

    setMessageLoader(true);
    setIsFetchingMessagesBelow(true);
    setShowMessagesFromStart(false);
    setSetMsgValue({ ...pendingMsg, [id]: newMessageToSend });
    setShowAckMsg(true);
    addMessagesToList([newMessageToSend]);
    sendMessageCMD(sessionInfo.sessionId, message, "TEXT");
    handleUpdateTypingStatus(false)
  };

  const handleCustomerRetryMsg = (msg) => {
    const { sendMessageCMD } = CometdActions(cometd);

    let message = { ...msg.message };
    let sessionInfo = props.activeConversation;

    setIsFetchingMessagesBelow(true);
    setShowMessagesFromStart(false);
    setShowAckMsg(true);

    sendMessageCMD(sessionInfo.sessionId, message, msg.convoType);
    timerLoader(2000);
  };

  const timerLoader = (time) => {
    setIsFetchingMessagesBelow(true);
    setTimeout(() => setIsFetchingMessagesBelow(false), time);
  };

  const parseFileTypeToSend = (file) => {
    if (file.type.toLowerCase().indexOf("audio") !== -1) {
      return "audio";
    } else if (file.type.toLowerCase().indexOf("video") !== -1) {
      return "video";
    } else if (file.type.toLowerCase().indexOf("image") !== -1) {
      return "image";
    } else {
      return "document";
    }
  };

  const sendMessageWithAttachemnts = (attachedFiles) => {
    setMessageLoader(true);
    setIsFetchingMessagesBelow(true);

    let sessionInfo = props.activeConversation;
    let messageAttachments = [];
    let messageTime = new Date();

    let id = messageTime.getTime();

    let fileUploadTasks = attachedFiles.map((file, index) => {
      let newfileType = parseFileTypeToSend(file);

      console.log("fileType", file, newfileType);

      return apiService
        .uploadMedia(file, newfileType, sessionInfo.sessionId)
        .then(
          (result) => {
            console.log("result", result);
            let mediaMessage = {
              message: {
                text: result.data.url,
                sentTimestamp: id,
                id: id,
              },
              id: id + index,
              type: MessageType.sent,
              timestamp: id,
              convoType: newfileType.toUpperCase(),
              creator: "CUSTOMER",
              // syntheticMessage: true,
            };

            setMessageLoader(false);
            setIsFetchingMessagesBelow(false);
            messageAttachments.push(mediaMessage);
            return result;
          },

          (error) => {
            console.log(
              "CALLING MESSAGE WITH ATTACHMENTS API FAILED ",
              error.response
            );
            showSnackBarWithMessage(
              "Something went wrong, Please check your internet connection"
            );
          }
        );
    });

    return Promise.all(fileUploadTasks)
      .then(() => {
        setMessageLoader(true);
        setIsFetchingMessagesBelow(true);

        const { sendMessageCMD } = CometdActions(cometd);
        addMessagesToList(messageAttachments)
        messageAttachments.forEach((messageItem, index) => {
          let message = {
            text: messageItem.message.text,
            sentTimestamp: id,
            id: id + index,
          };
          let convoType = messageItem.convoType;

          sendMessageCMD(sessionInfo.sessionId, message, convoType);
          console.log(messageItem, "messageItem")


          let pendingMsg = { ...setMsgValue };

          setSetMsgValue({
            ...pendingMsg,
            [id + index]: {
              message: {
                text: messageItem.message.text,
                sentTimestamp: id,
                id: id + index,
              },
              id: id + index,
              type: MessageType.sent,
              timestamp: id,
              convoType: convoType,
              creator: "CUSTOMER",
              syntheticMessage: true,
            },
          });
          setShowAckMsg(true);
        });

        setMessageLoader(false);
        setIsFetchingMessagesBelow(false);
      })
      .catch((error) => {
        console.log("Attchment error", error);
      });
  };

  const getSessionCloseMessage = () => {
    let sessionCloseMessage =
      props.config &&
      props.config.configDetails &&
      props.config.configDetails.sessionCloseMessage;
    if (!sessionCloseMessage) {
      HWLog.warn("Session Close Message Not Available In Config:");
      return null;
    }
    let messageTime = new Date();
    return {
      message: {
        text: sessionCloseMessage,
        sentTimestamp: messageTime.getTime(),
      },
      id: "session-close-message",
      type: MessageType.info,
      timestamp: messageTime.getTime(),
      convoType: "CLOSE",
      syntheticMessage: true,
    };
  };

  const containerStyle = () => {
    let config = props.config;
    return {
      ...config?.customDesign?.conversationPageContainer,
      height: localStorage.getItem("openInFullScreen") ? "85%" : "100%",
    };
  };

  const sendMessageWithCode = (textMessage, displayMessage) => {
    const { sendMessageCMD } = CometdActions(cometd);
    let messageTime = new Date();
    let id = messageTime.getTime();
    let newMessageToSend = {
      message: {
        text:
          typeof displayMessage === "object"
            ? displayMessage.name
            : displayMessage,
        sentTimestamp: id,
        id: id,
      },
      id: id,
      type: MessageType.sent,
      timestamp: id,
      convoType: "TEXT",
      creator: "CUSTOMER",
      syntheticMessage: true,
    };
    let sessionInfo = props.activeConversation;
    let message = {
      text:
        typeof displayMessage === "object" ? displayMessage.value : textMessage,
      sentTimestamp: id,
      id: id,
    };
    addMessagesToList([newMessageToSend]);
    let pendingMsg = { ...setMsgValue };

    setMessageLoader(true);
    setIsFetchingMessagesBelow(true);
    setSetMsgValue({ ...pendingMsg, [id]: newMessageToSend });
    setShowAckMsg(true);
    sendMessageCMD(sessionInfo.sessionId, message, "TEXT");
  };

  const setGifValueToList = (value) => setSetMsgValue(value);

  const handleSessionReloadClose = () => setShowReloadPopup(false);

  const handleSessionReload = () => {
    if (props?.config?.healthCheck) {
      setShowLoaderBotPopup(true);
      setShowErrorMsg("Please wait while fetching the messages");
      healthPingCounter = 0;
    }

    setMessages([]);
    fetchConversationHistoryCometd();
    setShowReloadPopup(false);
  };
  const muteNotification = (data) => {
    setPlaySound(data);

  }
  const state = {
    messages,
    xmppMessageHistory,
    previewFiles,
    isConversationClosed,
    showSnackBar,
    showSendChatTranscriptForm,
    showCloseDialog,
    isFetchingMessages,
    isReset,
    showGif,
    isLoading,
    finalValue,
    messageLoader,
    isFetchingMessagesBelow,
    showChatStatusLang,
    showChatStatusAttachment,
    disableLoader,
    customerAckObj,
    showAckMsg,
    setMsgValue,
    showReloadPopup,
    showLoaderBotPopup,
    showErrorMsg,
    agentPingStatus,
    showMessagesFromStart,
    snackBarMessage,
    open,
    isTypingPublished,
  };

  return (
    <div className="s360-conversation-page" id="s360-conversation-page">
      {showLoaderBotPopup ? (
        <span
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "80vh",
          }}
        >
          <CircularProgress />
          <p
            style={{
              position: "absolute",
              marginTop: " 11rem",
              fontWeight: 500,
              width: "75%",
            }}
          >
            {showErrorMsg}
          </p>
        </span>
      ) : (
        <>
          <ConversationHeader
            {...props}
            {...state}
            agentInfo={props?.agentInfo}
            playSound={playSound}
            muteNotification={(data) => muteNotification(data)}
            isActiveConversation={isActiveConversation}
            startNewConversation={startNewConversation}
            onSendChatTranscriptClick={onSendChatTranscriptClick}
            closeConversationClick={closeConversationClick}
            isShowToggle={showChatStatusLang}
            sessionId={props?.activeConversation?.sessionId}
          />
          {showReloadPopup && props.activeConversation.active && (
            <ReloadSessionContainer
              handleSessionReload={() => handleSessionReload()}
              handleSessionReloadClose={() => handleSessionReloadClose()}
            />
          )}
          <div
            className={`s360-conversation-page-container${isFullScreen ? "-fs" : ""}`}
            id="conver"
            style={containerStyle()}
          >
            <Conversation
              disableLoader={disableLoader}
              messagesLength={messages.length}
              parseSessionClose={parseSessionCloseResponse}
              isFetchingMessages={isFetchingMessages}
              messageLoader={messageLoader}
              {...props}
              {...state}
              actions={{ ...props.actions, ...actions }}
              startNewConversation={startNewConversation}
              isFetchingMessagesBelow={isFetchingMessagesBelow}
              customerAckObj={customerAckObj}
              handleCustomerRetryMsg={handleCustomerRetryMsg}
              sessionId={props?.activeConversation?.sessionId}
              isShowLanguageDropdown={isShowLanguageDropdown}
              setIsShowLanguageDropdown={setIsShowLanguageDropdown}
              selectedLanguage={selectedLanguage}
              setSelectedLanguage={setSelectedLanguage}
            />

            {/* show typing indicator */}
            {showTyping && <TypingIndicator />}
          </div>
          <div>
            {showGif && (
              <Popup
                handleClose={handleClose}
                addMessagesToList={addMessagesToList}
                addSetMsgValue={setGifValueToList}
                {...props}
              />
            )}
          </div>

          {isActiveConversation() && (!isShowLanguageDropdown) && (
            <InputBox
              {...props}
              {...actions}
              finalValue={finalValue}
              ref={messageRef}
              send={onMessageSend}
              disableInput={!!previewFiles?.length || !!(props?.isOffline ?? s360ConfigService?.config?.configDetails?.offline)}
              isOffline={!!(props?.isOffline ?? s360ConfigService?.config?.configDetails?.offline)}
              attchmentProps={{
                showChatStatusAttachment: showChatStatusAttachment,
                attachRef: file,
                onClickAttachment: () => file.current.click(),
                onChangeAttachment: onFileSelect,
              }}
              handleUpdateTypingStatus={handleUpdateTypingStatus}
            />
          )}
          <div
            className={`s360-conversation-page-footer-container${isFullScreen ? "-fs" : ""}`}
          >
            {!!previewFiles?.length && (
              <PreviewAttachmentFiles
                {...props}
                {...state}
                onRemovePreviewFile={onRemovePreviewFile}
                onAddPreviewFile={onFileSelect}
                files={previewFiles}
              />
            )}

            <DefaultFooter {...props} />
          </div>
          <Snackbar
            open={showSnackBar}
            onClose={handleSnackbarClose}
            message={snackBarMessage}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            key={"bottom-right-snackbar"}
            autoHideDuration={3000}
          />
          {showSendChatTranscriptForm && (
            <SendChatTranscriptForm
              {...props}
              {...state}
              onSendChatTranscript={sendChatTranscript}
              onClose={() => setShowSendChatTranscriptForm(false)}
            />
          )}
        </>
      )}
    </div>
  );
}

export default ConversationPage;
